import React from "react";

function PersonIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0351 9.86495C10.9443 9.85588 10.8354 9.85588 10.7356 9.86495C8.57577 9.79235 6.8606 8.02273 6.8606 5.84473C6.8606 3.62135 8.65745 1.81543 10.8899 1.81543C13.1133 1.81543 14.9192 3.62135 14.9192 5.84473C14.9101 8.02273 13.1949 9.79235 11.0351 9.86495Z"
        stroke="#424242"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.4977 13.2133C4.30155 14.6835 4.30155 17.0793 6.4977 18.5403C8.99332 20.2101 13.0861 20.2101 15.5818 18.5403C17.7779 17.0702 17.7779 14.6744 15.5818 13.2133C13.0952 11.5526 9.0024 11.5526 6.4977 13.2133Z"
        stroke="#424242"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PersonIcon;
